import GenerationInput from './GenerationInput'

export default GenerationInput